import actions from './pt-br/actions'
import dialogs from './pt-br/dialogs'
import filters from './pt-br/filters'
import forms from './pt-br/forms'
import permissions from './pt-br/permissions'
import resources from './pt-br/resources'

export default {
    actions: actions,
    dialogs: dialogs,
    filters: filters,
    forms: forms,
    permissions: permissions,
    resources: resources,
}
